import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { customStyles } from "../../styles/dataTableStyles";
import { toast } from "react-toastify";

import DropdownComp from '../dropdown';
import { MerchantDataColumns } from "./reportHelpers";
import { monthlySalesReportDataColumn } from "./monthlySalesRepCol";
import {
  SalesDataColumns,
  KeyReportColumns,
  SalesDateColumnsforSuperAdmin,
} from "./salesReport";
import { TopupDataColumns, TopupCreditDataColumns } from "./topUpReport";
import {
  ProductDataColumns,
  ProductDataColumnsMerchant,
} from "./productReportHelper";

import {
  keyUploadDataColumns,
} from "./keyUploadReportHelper";

import { api } from '../../api';
import { useQuery } from "../hooks/useQuery";
import ExcelJS from 'exceljs';

import { OrderReportColumns } from "./orderReportColumns";

export default function Reports(props) {
  const token = useSelector((state) => state.auth.token);
  const region = useSelector((state) => state.auth.region);
  const { userType: role } = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  let query = useQuery();
  const [isDownloadLoad, setIsDownloadLoad] = useState(false);



  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10); // Default page size
  // eslint-disable-next-line
  const [search, setSearch] = useState("");
  const [freshData, setFreshData] = useState(1);

  var today = new Date();
  var firstOfCurrentMonth;
  var ddStrt = 1;
  var ddEnd = today.getDate();
  var mm = today.getMonth() + 1;
  var yyyy = today.getFullYear();

  if (ddStrt < 10) {
    ddStrt = "0" + ddStrt;
  }
  if (ddEnd < 10) {
    ddEnd = "0" + ddEnd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  firstOfCurrentMonth = yyyy + "-" + mm + "-" + ddStrt;
  today = yyyy + "-" + mm + "-" + ddEnd;




  const [dataColumns, setDataColumns] = useState(
    role === 4
      ? role === 1
        ? SalesDateColumnsforSuperAdmin(region)
        : SalesDataColumns(region)
      : role === 3
        ? ProductDataColumnsMerchant(region)
        : ProductDataColumns(region)
  );
  // eslint-disable-next-line
  const [columns, setColumns] = useState([]);
  const [startDate, setStartDate] = useState(firstOfCurrentMonth);
  localStorage.setItem("startDate", startDate);
  const [endDate, setEndDate] = useState(today);
  localStorage.setItem("endDate", endDate);
  const [reportInput, setReportInput] = useState(
    role === 4 ? "sale" : "product"
  );
  localStorage.setItem("reportInput", reportInput);
  // eslint-disable-next-line
  const [updateData, setUpdateData] = useState(false);
  // eslint-disable-next-line
  const [reportLoad, setReportLoad] = useState(false);
  // eslint-disable-next-line
  const [keySearch, setKeySearch] = useState("");
  const [statusType, setStatusType] = useState("Completed");
  localStorage.setItem("status", statusType);
  // eslint-disable-next-line
  const [updatedReports, setupdatedReports] = useState({});
  const [transactionType, setTransactionType] = useState(3);
  // const [selectedKeyType, setSelectedKeyType] = useState({});
  // const [selectedRepStatus, setSelectedRepStatus] = useState({});
  // const [masterDataList, setMasterDataList] = useState([
  //   { value: "", label: "please select" },
  // ]);
  const [isLoading, setLoading] = useState(false);
  // const [toggle, setToggle] = useState(false);
  localStorage.setItem("transactionType", transactionType);
  // const keyTypeOptions = (options = [
  //   { value: "masterProd", label: "Master Product" },
  //   { value: "keyAssignedStatus", label: "Key Assigned Status" },
  // ]);
  // const ReportStatusOptions = (options = [
  //   { value: "1", label: "Assigned" },
  //   { value: "0", label: "Unassigned" },
  // ]);
  let options = [];

  if (role === 3) {
    options = [
      { value: "product", label: "Product" },
      { value: "sale", label: "Datewise " },
      { value: "topup", label: "TOPUP" },
    ];
  } else if (role === 4) {
    options = [{ value: "sale", label: "Datewise " }];
  } else {
    options = [
      { value: "product", label: "Product" },
      { value: "merchent", label: "Merchant" },
      { value: "sale", label: "Datewise " },
      { value: "monthly_sales_report", label: "Monthly Sales Report " },
      { value: "topup", label: "Credit Usage" },
      { value: "keyReport", label: "Key Report" },
      { value: "soldQuantityReport", label: "Sold Quantity Report" },
      { value: "merchantProductMarginReport", label: "Merchant Product Margin Report" },
      { value: "keyupload", label: "Upload Qty Report" },
      { label: "Order Report", value: "orderReport" },
    ];
  }
  // const handleToggle = () => {
  //   setToggle((togle) => !togle);
  // };
  const strtDt = query.get("startDate");
  const endDt = query.get("endDate");
  const repInput = query.get("reportInput");
  const statusTypeQuery = query.get("statusType");
  const transactType = query.get("transactionType");
  const hasQueryParam = strtDt && endDt && repInput;
  const hasSaleQueryParam = strtDt && endDt && repInput && statusTypeQuery;
  const hasTopupQueryParam = strtDt && endDt && repInput && transactType;
  // eslint-disable-next-line
  const hasEmptyParam = strtDt === "" && endDt == "" && repInput == "";

  const deleteQuery = () => {
    query.delete("reportInput");
    query.delete("startDate");
    query.delete("endDate");
    query.delete("statusType");
    query.delete("transactionType");
    navigate({
      search: `?${query.toString()}`,
    }, { replace: true });
  };
  // useEffect(() => {
  //   api.products.getMasterData().then((res) => {
  //     var masterList = [];
  //     if (res.code == 200) {
  //       for (let i of res.data.result) {
  //         masterList.push({ value: i.masterProdId, label: i.masterProdName });
  //       }
  //       setMasterDataList(masterList);
  //     }
  //   });
  // }, []);

  const handleRoute = (row) => {
    const reportType = localStorage.getItem("reportInput");
    const queryStrtDt = localStorage.getItem("startDate");
    const queryEndDt = localStorage.getItem("endDate");

    navigate(`/view-reports/${row.merchentId}/merchant/${row.merchentName}?startDate=${queryStrtDt}&endDate=${queryEndDt}&reportInput=${reportType}`);
  };

  const handleRouteTopup = (row) => {
    const reportType = localStorage.getItem("reportInput");
    const queryStrtDt = localStorage.getItem("startDate");
    const queryEndDt = localStorage.getItem("endDate");
    navigate(
      `/view-merchant/${row.merchentId}/topup/${row.merchent}?startDate=${queryStrtDt}&endDate=${queryEndDt}&reportInput=${reportType}&transactionType=${transactionType}`
    );
  };


  const handleRouteSale = (row) => {
     const reportType = localStorage.getItem("reportInput");
    const queryStrtDt = localStorage.getItem("startDate");
    const queryEndDt = localStorage.getItem("endDate");
    const statusTypeQ = localStorage.getItem("status");
    navigate(
      `/view-reports/${row.dateVelue}/sales/${row.dateVelue}?startDate=${queryStrtDt}&endDate=${queryEndDt}&reportInput=${reportType}&statusType=${statusTypeQ}`
    );
  };

  const handleRouteSaleAdmin = (row) => {
    const reportType = localStorage.getItem("reportInput");
    const queryStrtDt = localStorage.getItem("startDate");
    const queryEndDt = localStorage.getItem("endDate");
    const statusTypeQ = localStorage.getItem("status");
    navigate(
      `/view-reports/${row.dateVelue}/sales/${row.dateVelue}?startDate=${queryStrtDt}&endDate=${queryEndDt}&reportInput=${reportType}&statusType=${statusTypeQ}`
    );
  
  };



  useEffect(() => {
     setPage(1);
    // eslint-disable-next-line
  }, [search]);

    useEffect(() => {
    handleClickLoad();
    // eslint-disable-next-line
  }, [page,pageSize,token,search]);



  useEffect(() => {

    if (hasQueryParam || hasSaleQueryParam || hasTopupQueryParam) {
      setReportInput(repInput);
      setStartDate(strtDt);
      setEndDate(endDt);
      if (statusTypeQuery) {
        setStatusType(statusTypeQuery);
      }
      if (hasTopupQueryParam) {
        setTransactionType(transactType);
      }
 // eslint-disable-next-line
      const restoreFormBody = {
        type: repInput,
        startDate: strtDt,
        endDate: endDt,
        status: reportInput === "sale" ? statusTypeQuery : "",
        transactionType: reportInput === "topup" ? transactionType : "",
        pageSize: "10",
        pageNo: "1",
        searchKey: search
      };
      if (repInput === "merchent") {
        // setDataColumns(MerchantDataColumns(handleRoute));
      } else if (repInput === "sale") {
        // setDataColumns(
        //   role == 1 ? SalesDateColumnsforSuperAdmin : SalesDataColumns
        // );
      } else if (repInput === "topup") {
        // setDataColumns(role == 3 ? TopupCreditDataColumns : TopupDataColumns);
      }
      else if (repInput === "keyupload") {
        // setDataColumns(keyUploadDataColumns);
      }

      
    
    } else if (hasEmptyParam) {
      deleteQuery();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!hasQueryParam) {
      if (reportInput === "merchent") {
        // setDataColumns(MerchantDataColumns(handleRoute));
          // setTableData(staticData);
          // const restoreFormBody = {
          //   type: reportInput,
          //   startDate: startDate,
          //   endDate: endDate,
          //   status: reportInput == "sale" ? statusTypeQuery : "",
          //   transactionType: reportInput == "topup" ? transactionType : "",
          //   pageSize: pageSize,
          //   pageNo: page,
          // };
  
  
          // fetchReportData(restoreFormBody);
      } else if (reportInput === "sale") {
        // setDataColumns(
        //   role == 1 ? SalesDateColumnsforSuperAdmin : SalesDataColumns
        // );
      } else if (reportInput === "product") {
        
        // setDataColumns(
        //   role == 3 ? ProductDataColumnsMerchant : ProductDataColumns
        // );
   
        

        // console.log(dataColumns);

        // setTableData(staticData);

      
      } else if (reportInput === "keyReport") {
        // setDataColumns(KeyReportColumns);
      } else if (reportInput === "monthly_sales_report") {
        // setDataColumns(monthlySalesReportDataColumn);
      } 
      else if (reportInput === "keyupload") {
          // setDataColumns(keyUploadDataColumns);
      }
    else {
        // setDataColumns(role == 3 ? TopupCreditDataColumns : TopupDataColumns);
      }
    }
    // eslint-disable-next-line
  }, [reportInput,page,pageSize]);

  const handleClick = () => {
    
    if(freshData === 1){
    setPage(1);
    setPageSize(10); // or your default page size
    setFreshData(0);
    if(page !==1 ){
      return;
    }
     
    }

    setFreshData(0);
    handleClickLoad();
  }

  const handleClickLoad = () => {
    setLoading(true);

    let formBody = "";
    let formData = {
      start_date: startDate,
      end_date: endDate,
      pageNo: page,
      pageSize: pageSize,
      searchKey: search,
    };
    if (reportInput === "keyReport") {
      setDataColumns(KeyReportColumns);
      api.reports
        .getProductKeyLis(formData,token)
        .then((res) => {
          setColumns(res.data.result);
          setTableData(res.data.result)
          setupdatedReports(res.data.result);
          setTotalRows(res.data.totalCount);
          setUpdateData(true);
          setReportLoad(true);
          setLoading(false);
        })
        .catch((err) => console.log("error", err))
        .finally(() => setLoading(false));
    } else if (reportInput === "soldQuantityReport") {
        setTableData([]); 
        setTotalRows(0);
      api.reports.exportSoldQuantityReport({ startDate, endDate },token)
        .then((res) => {
          if (res && res.data && res.data.results && res.data.results.length > 0) {
            let results = res.data.results;
            let totalSoldAmountByProduct = res.data.totalSoldProductAmountByMerchent;

            let headerKeys = Object.keys(results[0]);
            headerKeys = headerKeys.filter(elementKey => {
              return elementKey !== 'productAmount' && elementKey !== 'productId' && elementKey !== 'productName';
            });

            // Create an Excel workbook and worksheet
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'Nodwin Gaming';
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.lastPrinted = new Date();

            const worksheet = workbook.addWorksheet('Qty Sold Report');

            let totalRow = ['Total'];

            // Set Columns
            let columns = [
              { header: 'Product Name', key: 'productName', width: 20 },
            ];

            headerKeys.forEach((elementKey) => {
              columns.push({ header: elementKey, key: elementKey, width: 20 });
              totalRow.push(totalSoldAmountByProduct[elementKey]);
            })
            worksheet.columns = columns;

            // Set Rows
            worksheet.addRows(results);

            // Add Total Count Row
            worksheet.addRow(totalRow);

            // Generate the Excel file
            workbook.xlsx.writeBuffer().then((buffer) => {
              const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `Sold_Quantity_Report_${new Date().getTime()}.xlsx`;
              a.click();
              window.URL.revokeObjectURL(url);
            });
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error exporting report:", err);
          setLoading(false);
        });
    } else if (reportInput === "merchantProductMarginReport") {
       setTableData([]); 
       setTotalRows(0);
      api.reports.exportMerchantMarginReport({},token)
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            let results = res.data;
            let headerKeys = Object.keys(results[0]);
            headerKeys = headerKeys.filter(elementKey => { return elementKey !== 'merchentName' });

            // Create an Excel workbook and worksheet
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'Nodwin Gaming';
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.lastPrinted = new Date();

            const worksheet = workbook.addWorksheet('Merchant Margin Report');

            // Set Columns
            let columns = [{ header: 'Merchant Name', key: 'merchentName', width: 40 }];
            headerKeys.forEach((elementKey) => {
              columns.push({ header: elementKey, key: elementKey, width: 20 });
            })
            worksheet.columns = columns;

            // Set Rows
            worksheet.addRows(results);

            // Generate the Excel file
            workbook.xlsx.writeBuffer().then((buffer) => {
              const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `Merchant_Margin_Report_${new Date().getTime()}.xlsx`;
              a.click();
              window.URL.revokeObjectURL(url);
            });
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error exporting report:", err);
          setLoading(false);
        });
        
    } 
    else if (reportInput === "orderReport") {
        const viewOrder = (rowId) => {
          console.log(rowId); // check what is coming
          navigate(`/orders-info/${rowId}`);
        };
        
      setDataColumns(OrderReportColumns(viewOrder));

      const formBody = {
        startDate,
        endDate,
        pageNo: page,
        pageSize,
        searchKey: search,
      };

      api.orders
        .getOrdersData(formBody, token)
        .then((res) => {
          if (res.success) {
            setTableData(res.data.result || []);
            setTotalRows(res.data.totalCount || 0);
          } else {
            setTableData([]);
            setTotalRows(0);
          }
        })
        .catch(() => {
          setTableData([]);
          setTotalRows(0);
        })
        .finally(() => setLoading(false));
    }

    else {

      if (role === 3) {
        formBody = {
          type: reportInput,
          startDate: startDate,
          endDate: endDate,
          status: reportInput === "sale" ? statusType : "",
          pageSize: pageSize,
          pageNo: page,
          transactionType: transactionType,
          searchKey: search
        };
      } else if (reportInput === "topup") {
       
        formBody = {
          type: reportInput,
          startDate: startDate,
          endDate: endDate,
          transactionType: transactionType,
          pageSize: pageSize,
          pageNo: page,
          searchKey: search
        };


        
      }
      else if (reportInput === "keyReport") {
        formBody = {
          type: "keyReport",
          startDate: startDate,
          endDate: endDate,
          searchKey: search
        };
      
      } else {
        formBody = {
          type:
            reportInput === "monthlySalesReport"
              ? "monthly_sales_report"
              : reportInput,
          startDate: startDate,
          endDate: endDate,
          status: reportInput === "sale" ? statusType : "",
          pageSize: pageSize,
          pageNo: page,
          searchKey: search
        };
      }

    

      if(reportInput === "product"){
        setDataColumns(
          role === 3 ? ProductDataColumnsMerchant(region) : ProductDataColumns(region)
        );
   
        fetchReportData(formBody);
      }else if (reportInput === "merchent") {

        setDataColumns(MerchantDataColumns(handleRoute,region));
        fetchReportData(formBody);

      }else if (reportInput === "monthly_sales_report") {

        setDataColumns(monthlySalesReportDataColumn(region));
        fetchReportDataSale(formBody);
   
      } else if (reportInput === "topup") {
        
        setDataColumns(role === 3 ? TopupCreditDataColumns(region) : TopupDataColumns(handleRouteTopup,region));

        fetchReportData(formBody);
      } 
      else if (reportInput === "sale") {
        setDataColumns(
          role === 1 ? SalesDateColumnsforSuperAdmin(handleRouteSaleAdmin,region) : SalesDataColumns(handleRouteSale,region)
        );
        fetchReportData(formBody);
      }
      else if (reportInput === "keyupload") {
      setDataColumns(keyUploadDataColumns);
           fetchReportData(formBody);
      } 


      // api.reports
      //   .getReportsData(formBody,token)
      //   .then((res) => {
      //     setColumns(res.data);
      //     setTableData(res.data.result)
      //     setupdatedReports(res.data);
      //     setUpdateData(true);
      //     setReportLoad(true);
      //   })
      //   .catch((err) => console.log("error", err))
      //   .finally(() => setLoading(false));
    }
  };

  function handleChangeReport(e) {
    setReportInput(e.value);
    setFreshData(1);
    deleteQuery();
   
  }

  const StatusOptions = [
    { value: "Processing", label: "Processing" },
    { value: "Completed", label: "Completed" },
    { value: "Failed", label: "Failed" },
  ];

  const transactionTypeData = [
    { value: 1, label: "Debit" },
    { value: 2, label: "Credit" },
    { value: 3, label: "Credit and Debit" },
  ];

  const handleChangeStatus = (e) => {
    setStatusType(e.value);
  };

  const handleTransactionType = (e) => {
    setTransactionType(e.value);
  };



  const downLoadExcel = () => {
    const date = new Date();
    const fileName = `${reportInput}_${date.getDate()}_${date.getMonth() +
      1}_${date.getFullYear()}`;

   
      if (reportInput === "orderReport") {
  setIsDownloadLoad(true);

  api.orders
    .exportAllOrders(
      {
        startDate: startDate,
        endDate: endDate,
        searchKey: search,
      },
      token
    )
    .then((res) => {
      const fileData =
        Array.isArray(res?.data)
          ? res.data.map((dt) => ({
              OrderId: dt.orderId ?? "",
              OrderDate: dt.orderDate
                ? new Date(dt.orderDate).toLocaleString()
                : "",
              MerchantName: dt.merchentName ?? "",
              OrderNo: dt.orderNo ?? "",
              Email: dt.orderEmailId ?? "",
              Products: dt.ordersItems ?? "",    
              Quantity: dt.ordersQuantity ?? 0,
              TotalAmount: dt.orderAmount ?? 0,
              NetAmount: dt.netAmount ?? 0,
              Status: dt.status ?? "",
            }))
          : [];

      console.log("Order Report Rows:", fileData.length);
      console.log("First Row:", fileData[0]);

      const ws = XLSX.utils.json_to_sheet(fileData);
      const wb = {
        Sheets: { Orders: ws },
        SheetNames: ["Orders"],
      };

      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });

      FileSaver.saveAs(
        data,
        `Order_Report_${Date.now()}.xlsx`
      );

      setIsDownloadLoad(false);
    })
    .catch((err) => {
      console.error("Order Report download error:", err);
      toast.error("Order Report download failed");
      setIsDownloadLoad(false);
    });

  return;
}

  /* ===============================
     ⬇️ EXISTING REPORT DOWNLOADS
     (UNCHANGED)
     =============================== */








    let formBody = "";
    if (reportInput === "topup") {
      formBody = {
        type: reportInput,
        startDate: startDate,
        endDate: endDate,
        transactionType: transactionType,
        searchKey: search,
      };
    } else {
      formBody = {
        type: reportInput,
        startDate: startDate,
        endDate: endDate,
        searchKey: search,
      };
    }
    setIsDownloadLoad(true); 
    api.reports
      .export(formBody,token)
      .then((res) => {
        const fileData =
          res.data &&
          res.data.map((dt) => {
            if (reportInput === "keyReport") {
              return {
                "ProductKey Mask": dt.productKeyMask,
                "Created At": new Date(dt.createdAt).toLocaleDateString(
                  "en-ca"
                ),
                "Updated At": new Date(dt.updatedAt).toLocaleDateString(
                  "en-ca"
                ),
                "Master product name": dt.masterproductname,
                Merchant: dt.merchant,
                "Order Id": dt.orderId,
                Status: dt.status,
              };
            } else if (reportInput === "merchent") {
              return {
                creditBalanceAmount: dt.creditBalanceAmount,
                merchentName: dt.merchentName,
                totalOrderAmount: dt.totalOrderAmount,
                totalOrders: dt.totalOrders,
              };
            } else if (reportInput === "product") {
              return {
                ProductName: dt.productName,
                TotalOrderAmount: dt.totalOrderAmount,
                TotalSaleMargin: dt.totalSaleMargin,
                TotalSoldQuantity: dt.totalSoldQuantity,
              };
            } else if (reportInput === "sale") {
              return {
                dateVelue: dt.dateVelue,
                totalOrderAmount: dt.totalOrderAmount,
                totalOrders: dt.totalOrders,
                totalSoldProducts: dt.totalSoldProducts,
              };
            }  else if (reportInput === "monthly_sales_report") {
              return {
                MerchentName: dt.merchentname,
                OrderAmount: dt.orderamount,
                DiscountAamount: dt.discountamount,
                ProductAmount: dt.productamount,
                ProductMargin: dt.productmargin,
              };
            } 
            else {
              return {
                merchent: dt.merchent,
                paymentDate: new Date(dt.paymentDate).toLocaleDateString(
                  "en-ca"
                ),
                amount: dt.amount,
                creditBalanceAmount: dt.creditBalanceAmount,
                notes: dt.notes,
                transactionNo: dt.transactionNo,
                transactionType: dt.transactionType,
              };
            }
          });
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const ws = XLSX.utils.json_to_sheet(fileData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setIsDownloadLoad(false); 
      })
      .catch((err) => {
        console.log(err);
        setIsDownloadLoad(false);
        toast.error('Download failed');
      });


  };


  const fetchReportData = async (FormBody) => {
      setLoading(true);
   
      try {
     
        const res = await api.reports.getReportsData(FormBody, token); // you can pass pageNo, searchKey, pageSize if needed
    
        if (res.success === true) {
        
      
        setTableData(Array.isArray(res.data.result) ? res.data.result : []);
        setTotalRows(res.data.totalCount);
        } else {
          setTableData([]); 
          setTotalRows(0);
         
        }
     
        if(repInput !==  null && reportInput !== repInput){
          setTableData([]); 
          setTotalRows(0);
        }
       
      } catch (error) {
          setTableData([]); 
          setTotalRows(0);
      } finally {
        setLoading(false);
      }
     };


     const fetchReportDataSale = async (FormBody) => {
      setLoading(true);
      try {
     
        const res = await api.reports.getReportsData(FormBody, token); // you can pass pageNo, searchKey, pageSize if needed
        if (res.success === true) {
        setTableData(Array.isArray(res.data.monthly_sales_report_data) ? res.data.monthly_sales_report_data : []);
        setTotalRows(res.data.totalCount);
        } else {
          setTableData([]); 
          setTotalRows(0);
         
        }
      } catch (error) {
        setTableData([]); 
        setTotalRows(0);
      } finally {
        setLoading(false);
      }
     };
  

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
                {isDownloadLoad && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    pointerEvents: 'none', // Allow clicks through
                    zIndex: 999,
                  }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
                )}
            <h1 className="sec-header" style={{ padding: "1rem 0 0 0" }}>
              Reports{" "}
              {reportInput &&
                ` :- ${reportInput.toUpperCase() === "MERCHENT"
                  ? "MERCHANT"
                  : reportInput.toUpperCase() === "SALE"
                    ? "DATEWISE"
                    : reportInput.toUpperCase() === "MONTHLY_SALES_REPORT"
                      ? "MONTHLY SALES REPORT"
                      : reportInput.toUpperCase()
                } `}
            </h1>
            <div
              className="table-head  card card-table"
              style={{ border: "", padding: "1.25rem" }}
            >
              <div className="row" style={{ border: "" }}>
                <div className="form-group col-md-3">
                  <DropdownComp
                    id="reportInput"
                    name="reportInput"
                    options={options}
                    onChange={(e) => {
                      handleChangeReport(e);
                      setReportLoad(false);
                      setUpdateData(false);
                    }}
                    value={
                      hasQueryParam
                        ? options.filter((opt) => opt.value === repInput)
                        : options.filter((opt) => opt.value === reportInput)
                    }
                    label="Report Type"
                    placeholder="Select Report Type"
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="startDate">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    max={new Date().toLocaleDateString("en-ca")}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label htmlFor="endDate">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    max={new Date().toLocaleDateString("en-ca")}
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group col-md-3">
                    {reportInput !== "keyupload" && (

                  <span>
                    <i
                      className="bx bx-menu float-right bold dropdown-toggle p-2"
                      data-toggle="dropdown"
                      style={{ cursor: "pointer" }}
                    ></i>
                    <div
                      className="dropdown-menu dropdown-list1"
                      style={{ cursor: "pointer" }}
                    >
                      <span
                        className="dropdown-item file mr-2"
                        onClick={downLoadExcel}
                      >
                        <i className="bx bxs-file-pdf mr-2"></i>Download Excel
                      </span>

                    </div>
                  </span>
                    )}

                </div>
              </div>

              <div className="row" style={{ alignItems: "flex-end" }}>
                {reportInput === "sale" && (
                  <div className="form-group col-md-3">
                    <DropdownComp
                      id="statusInput"
                      name="statusInput"
                      options={StatusOptions}
                      onChange={(e) => {
                        handleChangeStatus(e);
                        // setUpdateData(true);
                      }}
                      value={StatusOptions.find((i) => i.value === statusType)}
                      label="Status Type"
                      placeholder="Select Status Type"
                    />
                  </div>
                )}
                {reportInput === "topup" && (
                  <div className="form-group col-md-3">
                    <DropdownComp
                      id="transactionType"
                      name="transactionType"
                      options={transactionTypeData}
                      onChange={(e) => {
                        handleTransactionType(e);
                        // setUpdateData(true);
                      }}
                      value={transactionTypeData.find(
                        (i) => i.value === transactionType
                      )}
                      label="Transaction Type"
                      placeholder="Select Transaction Type"
                    />
                  </div>
                )}
                {/* {reportInput == "keyReport" && (
                  <div className="form-group col-md-3">
                    <DropdownComp
                      id="keyType"
                      name="keyType"
                      options={keyTypeOptions}
                      onChange={(selectedVal) => {
                        setKeyType((prev) => {
                          if (prev.value === selectedVal.value) {
                            return prev;
                          }
                          return {
                            selectedKeyType: selectedVal,
                          };
                        });
                        handleToggle();
                      }}
                      value={keyTypeOptions.find(
                        (i) => i.value === selectedKeyType.value
                      )}
                      label="Key Type"
                      placeholder="Select Key Type"
                    />
                  </div>
                )} */}
                {/* {reportInput == "keyReport" && (
                  <div className="form-group col-md-3">
                    <DropdownComp
                      id="reportStatus"
                      name="reportStatus"
                      options={ReportStatusOptions || masterDataList}
                      onChange={(selectedVal) => {
                        setSelectedRepStatus(selectedVal)
                      }}
                      value={ReportStatusOptions.find(
                        (i) => i.value === ReportStatusOptions.value
                      )}
                      label="Report Status"
                      placeholder="Select Report Status"
                    />
                  </div>
                )} */}
                <div className="form-group col-md-3 updatetable">
                  <button
                    type="button"
                    style={{ width: "100%" }}
                    onClick={handleClick}
                    className="btn mt-3 submit-btn"
                    htmlFor="gridCheck"
                    disabled={isLoading}
                  >
                    Get Report
                  </button>
                </div>
              </div>
              {/*  */}
            </div>

            <div className="card card-table">
              <div className="card-header card-header-title">
                {/* Reports */}
              </div>

              <div className="card-body gatepass-saveoutput">
                <div className="reports updatetable">
         

           <input
            type="text"
            placeholder="Search"
            className="form-control"
            style={{ width: "200px" , marginBottom: "10px", float:"right" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />


                <DataTable
                  columns={dataColumns}
                  data={tableData}
                  progressPending={isLoading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={page}
                  onChangePage={setPage}
                  onChangeRowsPerPage={(newPageSize, newPage) => {
                    setPageSize(newPageSize);
                    setPage(newPage); // Reset to selected page
                  }}
                  highlightOnHover
                  customStyles={customStyles} // Apply custom styles
                  responsive // ✅ Enable responsive mode
                  noHeader={false}
                  noTableHead={false}
                  wrap // ✅ Prevents horizontal scroll
                />










                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
}
